import { connect } from 'react-redux';
import { Overview as OverviewComponent } from '../components/overview';
import { createMediaModalAction } from '@shared/actions/actions';
export const mapStateToProps = (state, ownProps)=>{
    return ownProps;
};
export const mapDispatchToProps = (dispatch)=>{
    return {
        openMediaModal: (payload)=>{
            dispatch(createMediaModalAction({
                showModal: true,
                payload
            }));
        }
    };
};
const Overview = connect(mapStateToProps, mapDispatchToProps)(OverviewComponent);
export default Overview;
